module.exports = __webpack_public_path__ + "static/media/6.20bf9ec2.jpg";